import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { MonthWiseModel } from 'src/app/models/department-app-verification.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first, shareReplay } from 'rxjs';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-atal-user',
  templateUrl: './atal-user.component.html',
  styleUrls: ['./atal-user.component.scss']
})
export class AtalUserComponent implements OnInit {


  public atalUserData: any = [];
  public filterdDataForExport: any = [];
  
  
  appVerificationItems: MenuItem[];
 
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];


  public userID: any;
  public routePath: any;
  public subjectSub: any;
  public selectedYear: any;

  public loading: boolean = false;
  public subscriptions: any = [];

  constructor(private reportsService:ReportsService,
    private messageService:MessageService,
    private router: Router,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService
    ) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    // this.loadData();
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        let router=this.router.url
        this.routePath=router.split('/')
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
    
        this.loadData(this.selectedYear)
      }  
    );

    
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.filterdDataForExport, "ATAL_BHUJAL_USER_REPORT");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filterdDataForExport, "7500_DEMO_REPORT");
      //   }
      // },
    ];
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear){
    // this.loader.start();
    this.loading = true;
    let sub = this.reportsService.getAtalReport(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Atal Bhujal User Report', '', new Date(), 'Success');
            
            if (data?.length > 0) {
              this.atalUserData = data;
              this.filterdDataForExport = data;
            }else if(data?.length == 0) {
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.atalUserData = [];
              this.filterdDataForExport = [];
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Atal Bhujal User Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });

        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'District': d.District,
          '':'',

          'NoOfCases (Applications)': d.NoOfCases,
          'NoOfApprovedCases (Applications)': d.NoOfApprovedCases,       
          'TotalArea (Applications)': d.TotalArea,
          ' ':'',
          'NoOfCases (Estimation)': d.NoOfCasesEst,
          'NoOfApprovedCases (Estimation)': d.NoOfApprovedCasesEstimation,
          'TotalArea (Estimation)': d.TotalAreaEST,
          'Amount (Estimation)': d.AmountEst,
          '  ':'',
          'NoOfCases (PV)': d.NoOfCasesPV,
          'NoOfApprovedCases (PV)': d.NoOfApprovedCasesPV,
          'TotalArea (PV)': d.TotalAreaPV,
          'Amount (PV)': d.AmountPV,
          '   ':'',
          'NoOfCasesSubsidy (Subsidy Disbusment)': d.NoOfCasesSubsidy,
          'ApprovedSubsidyApps (Subsidy Disbusment)': d.ApprovedSubsidyApps,
          'TotalAreaSubsidy (Subsidy Disbusment)': d.TotalAreaSubsidy,
          'AmountSubsidy (Subsidy Disbusment)': d.AmountSubsidy,
          'SubsidyPaid (Subsidy Disbusment)': d.SubsidyPaid,
        }
      })     
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  // downloadSheetAsPdf(modelData, filename) {
  //   this.cols = [
  //     {field: 'Date', header: 'Date'},
  //     { field: 'ChallanDeposited', header: 'Challan Deposited' },
  //     { field: 'AmountDeposited', header: 'Amount Deposited' },
  //     { field: 'ChallanRejected', header: 'Challan Rejected' },
  //     { field: 'AmountRejected', header: 'Amount Rejected' },
  //   ];
  //   this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
  //   import("jspdf").then(jsPDF => {
  //     import("jspdf-autotable").then(x => {
  //       const doc = new jsPDF.default(0, 0);
  //       doc.autoTable(this.exportColumns, modelData);
  //       doc.save(`${filename}.pdf`);
  //     })
  //   })
  // }

  tableDataFunction(event: any) {
    this.filterdDataForExport = event.filteredValue
    // this.tempDayWise=event.filteredValue
    // //console.log(event);
    // this.arrayIndex=0;
    // // console.log(this.vendorWise);
    // this.calculateTotalApp() ;
  }

  onPage(event:any) {
    // this.arrayIndex=event.first;
    // this.calculateTotalApp()
    //console.log(event);
  }

// calculateTotalApp() {
//         this.totalChallanDeposited=0;
//         this.totalAmountDeposited=0;
//         this.totalChallanRejected=0;
//         this.totalAmountRejected=0;
        
//           for(let i=this.arrayIndex ;this.tempDayWise.length>10?i<this.arrayIndex+10:i<this.tempDayWise.length;i++) {
//             this.totalChallanDeposited +=this.tempDayWise[i].ChallanDeposited;
//             this.totalAmountDeposited +=this.tempDayWise[i].AmountDeposited;
//             this.totalChallanRejected +=this.tempDayWise[i].ChallanRejected;
//             this.totalAmountRejected += this.tempDayWise[i].AmountRejected;
  
//           }             
//     }

  // calculateGrandTotal(){
  //   this.grandTotalChallanDeposited=0;
  //   this.grandTotalAmountDeposited=0;
  //   this.grandTotalChallanRejected=0;
  //   this.grandTotalAmountRejected=0;
  //   for(let dayData of this.tempDayWise) {
  //     this.grandTotalChallanDeposited += dayData.ChallanDeposited;
  //     this.grandTotalAmountDeposited += dayData.AmountDeposited;
  //     this.grandTotalChallanRejected += dayData.ChallanRejected;
  //     this.grandTotalAmountRejected += dayData.AmountRejected;
  // }
  // }

}

